import React from "react"
import { Link } from "gatsby"
import Col from "react-bootstrap/Col"
import Flash from "react-reveal/Flash"
import Fade from "react-reveal/Fade"
import { PaperAirplaneIcon } from "@primer/octicons-react"

const Collaborate = () => {
  return (
    <section className="row mx-0 mt-xl-4 mt-lg-4 mt-md-4">
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={9}
        xl={9}
        style={{ boxShadow: "0 3px 8px #646464" }}
        className={`text-center mx-auto py-5 wfBackground`}
      >
        <Fade right>
          <h2 className="mb-0 mx-auto display-4">Hello I'm Sungharsh</h2>
        </Fade>
        <hr className="mx-5 mt-0" style={{ background: "#f15842" }} />
        <Fade left>
          <p>
            I can help you bring innovation to life from concept to prototyping,
            design, software development, to production. As a team member I am
            ready to help you bring your concept to life with in the time span
            and succeed your goals.
          </p>
        </Fade>
        <Flash delay={1000}>
          <Link
            to="/Contact"
            type="button"
            role="button"
            className="btn btn-outline-light btn-main text-monospace customBtn shadow pr-3"
          >
            <span className={`badge badge-pill pl-1`}>
              <PaperAirplaneIcon size={16} aria-label="Design icon" />
            </span>
            <strong>CONTACT </strong>
          </Link>
        </Flash>
      </Col>
    </section>
  )
}

export default Collaborate
